import { motion } from 'motion/react';
import { Card } from './ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface PressureChartProps {
  data: Array<{
    time: string;
    bmp_pres: number;
  }>;
}

export function PressureChart({ data }: PressureChartProps) {
  const formattedData = data.map(item => ({
    time: new Date(item.time).toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' }),
    'Ciśnienie': parseFloat(item.bmp_pres.toFixed(2)),
  }));

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.5 }}
    >
      <Card className="p-6">
        <h3 className="mb-4">Ciśnienie atmosferyczne — w zależności od wybranego okresu czasu</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={formattedData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis 
              dataKey="time" 
              stroke="#6b7280"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="#6b7280"
              style={{ fontSize: '12px' }}
              domain={['dataMin - 5', 'dataMax + 5']}
              label={{ value: 'hPa', angle: -90, position: 'insideLeft' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
              }}
              formatter={(value: number) => `${value.toFixed(2)} hPa`}
            />
            <Line 
              type="monotone" 
              dataKey="Ciśnienie" 
              stroke="#8b5cf6" 
              strokeWidth={3}
              dot={{ r: 4, fill: '#8b5cf6' }}
              animationDuration={2000}
            />
          </LineChart>
        </ResponsiveContainer>
      </Card>
    </motion.div>
  );
}
